import { BasicEntity } from '@/types/Catalogs'

export enum GroupStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}

export class GroupEntity {
  allSubgroupIds: number[]
  siblingIds: number[]
  id: number
  name: string
  status: GroupStatus = GroupStatus.ACTIVE
  domain: BasicEntity
  subGroups: GroupEntity[]
  users: BasicEntity[]
  projects: BasicEntity[]
  creationDate: Date
  creationUser: BasicEntity
  updateDate: Date
  updateUser: BasicEntity
  _selected: boolean

  static getInstanceForEdit () {
    const instance = new GroupEntity()
    instance.name = ''
    instance.domain = new BasicEntity(0, '')
    instance.subGroups = []
    instance.users = []
    instance.projects = []
    return instance
  }
  static getStatus (group: GroupEntity) {
    let status: string
    if (group.status === GroupStatus.ACTIVE) {
      status = 'Activo'
    } else if (group.status === GroupStatus.INACTIVE) {
      status = 'Inactivo'
    } else {
      status = 'Sin estado'
    }
    return status
  }
  /** Validates if the name has a correct format */
  validateName () {
    return typeof this.name === 'string' && this.name.length > 0
  }
  /** Validates if the domain has a correct format */
  validateDomain () {
    return this.domain && this.domain.name && this.domain.id >= 0
  }
  /** Validates if the subgroups has a correct format */
  validateSubgroups () {
    return Array.isArray(this.subGroups)
  }
  /** Validates if the users has a correct format */
  validateUsers () {
    return Array.isArray(this.users)
  }
  /** Validates if the projects has a correct format */
  validateProjects () {
    return Array.isArray(this.projects)
  }
  /** Validates if the intances has the minimun required values for its creation */
  validatesRequiredValues () : string[] {
    const missingValues: string[] = []
    if (!this.name) missingValues.push('Nombre')
    if (!this.validateDomain()) {
      missingValues.push('DominioId')
    }
    return missingValues
  }
  validateFormatProperties () : string[] {
    const invalidValues: string[] = []
    if (!this.validateName()) invalidValues.push(`Nombre: ${this.name}`)
    if (!this.validateDomain()) invalidValues.push(`Domain: "${this.domain.id}-${this.domain.name}"`)
    if (!this.validateSubgroups()) invalidValues.push(`SubgruposIds: ${this.subGroups}`)
    if (!this.validateUsers()) invalidValues.push(`UsuariosIds: ${this.users}`)
    if (!this.validateProjects()) invalidValues.push(`ProyectosIds: ${this.projects}`)
    return invalidValues
  }
}

export class GroupCatalogFilters {
  domain: number
  loadRelations: boolean
  status: GroupStatus
  fromToDates: Date[]
}
